import React from "react";
import styles from "./FirstUpPopup.module.less";
import Countdown from "@/components/Countdown";
import useDialogManager from "@/utils/useDialogManager";
import { useFirstUpRecharge } from "../useFirstUpRecharge";
import { getCountryAsset } from "@/utils/countryAssetUtils";
import { getCurrentCountryCode } from "@/utils/countryConfigUtils";

import MarketingImagePopup from "@/features/common/marketingPopup";

interface FirstUpPopupProps {
  onClose: () => void;
  onActionClick?: () => void;
}

const FirstUpPopup: React.FC<FirstUpPopupProps> = ({
  onClose,
  onActionClick,
}) => {
  const { timeOutData } = useFirstUpRecharge();
  const { openWallet } = useDialogManager();
  const isMexico = getCurrentCountryCode()?.toUpperCase() === "MX";

  const bannerImage = getCountryAsset("firstUpBanner50");

  /* 倒计时结束 */
  function onCountdownEnd() {
    onClose();
  }

  // 处理 "PAY XXX" 按钮点击
  const handlePayClick = () => {
    // 打开钱包弹窗
    openWallet();
    // 如果存在 onActionClick 则执行
    if (onActionClick) {
      onActionClick();
    } else {
      onClose();
    }
  };

  // 处理 "MORE OFFERS INSIDE" 点击
  const handleMoreOffersClick = () => {
    // 打开钱包弹窗
    openWallet();
    if (onActionClick) {
      onActionClick();
    } else {
      onClose();
    }
  };

  return (
    <MarketingImagePopup
      imageSrc={bannerImage}
      imageAlt="First Deposit Bonus Banner"
      onImageClick={handlePayClick}
      onClose={onClose}
      imageClassName={styles.bannerImage}
      imageOverlay={
        <div className={styles.countdown} onClick={handlePayClick}>
          {!isMexico && timeOutData > 0 && (
            <Countdown
              format="DD HH:mm:ss"
              warnTime={10800000}
              autoFormatDay={true}
              endTime={timeOutData}
              onCountdownEnd={onCountdownEnd}
              className={styles.countdownTimer}
            />
          )}
        </div>
      }
      footer={
        <button
          type="button"
          className={styles.moreOffers}
          onClick={handleMoreOffersClick}
        >
          MORE OFFERS INSIDE
        </button>
      }
    />
  );
};

export default FirstUpPopup;
